const getShortId  = (id) => {
    if (!id) {
        return '';
    }
    return id.slice(0,8) + id.slice(22);
}

export default getShortId;
